export { default as ProductsListItemSimilarSearchButton } from './ProductsListItemSimilarSearchButton';
